export default function getResource(label, vars = []) {
    const resources = {
        addToBasketShort: 'Ajouter',
        remove: 'Supprimer',
        joinToAccess: 'Adhérez pour accéder',
        signInToAccess: 'Sign in to access',
        exclusive: 'Exclusivement'
    };
    return resources[label];
}
